import React from "react";
import { useContext } from "react";
import { useHistory } from "react-router-dom";
import { Context } from "../Store";
import styles from "./Form.module.scss";
import ReactGA from "react-ga4";

const Form = () => {
  const [state] = useContext(Context);
  const history = useHistory();

  const handleShareClick = () => {
    history.push(`/${state.guid}/share`);
  };

  let trackEvent = (category, action, label = "") => {
    ReactGA.event({
      category: category,
      action: action,
      label: label,
    });
  };

  return (
    <div className={`${styles.form} section section--padded`}>
      <h2>Got something brilliant?</h2>
      <p>
        We're collecting the most epic moments. We're talking killer throws, victory dances, group reactions and
        photobombs. Share yours with us to be featured on our website and social channels!
      </p>
      <button
        onClick={() => {
          handleShareClick();
          trackEvent("Social Form", "Share Button Clicked");
        }}
      >
        Share it with us
      </button>
    </div>
  );
};

export default Form;
